export const getFileSize = number => (number / 1048576).toFixed(1);
